import React, { Component } from "react";

class Popup extends Component {
  constructor(props) {
    super(props);
  }
  
  render = () => {
    const {
      header,
      content,
      className,
      style,
      closePopup,
      closeRight,
    } = this.props;
    
    return (
      <div className={`popup-container ${className || ''}`} style={style || {}}>
        <div className={`popup-close ${closeRight ? 'popup-close-right' : 'popup-close-left'}`} onClick={() => closePopup != null && closePopup()}>
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11 1L1 11" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M1 1L11 11" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        <div className="popup-body">
          { header != null &&
            <p className="popup-header">
              {header}
            </p>
          }
          <div className="popup-content">
            {content}
          </div>
        </div>
      </div>
    );
  }
}

export default Popup;